import { generateQueryKey } from 'query';

// TODO: create query key as const - 82948
export const getConsentsKey = (params: { consentIds?: string[] }) => generateQueryKey(['consents', params]);
